import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CheckoutState, SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";

interface Props {
  open: boolean;
  handleClose: () => void;
}

const EmailVolumePromoDialog = ({ open, handleClose }: Props) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { setUpgradeDialogSource, setOpenCheckoutDialog } =
    useContext(SubscriptionContext);

  const handleAddOn = () => {
    setUpgradeDialogSource("Email Volume Dialog Source");
    const state: CheckoutState = {
      plan: AddOnItemName.email_volume_yearly,
      source: "Email Volume Promo Dialog",
      pageSource: window.location.pathname,
    };
    setOpenCheckoutDialog(state);
    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      fullScreen={isMobileScreen}
    >
      <IconButton
        onClick={handleClose}
        sx={{ fontSize: 12, position: "absolute", top: 10, right: 10 }}
      >
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>

      <DialogContent sx={{ p: 4 }}>
        <Typography variant="h4" textAlign={"center"} sx={{ mb: 2 }}>
          NEW! Add 150 Pitches to Your VA Plan 🚀
        </Typography>

        <Typography textAlign={"center"} sx={{ mb: 2 }}>
          You can now send 150 pitches every month with our new Pitch Add-on.
        </Typography>
        <Typography textAlign={"center"} sx={{ mb: 2 }}>
          Get 50% more pitches sent for you - upgrade your plan today.
        </Typography>
      </DialogContent>
      <Grid container justifyContent={"center"} sx={{ mb: 3 }}>
        <Button
          onClick={handleAddOn}
          color="primary"
          disableElevation
          variant="contained"
        >
          Add Now
        </Button>
      </Grid>
    </Dialog>
  );
};

export default EmailVolumePromoDialog;
